var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetirement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_5686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6259 18.627 23.9981 11.9971 23.999C5.37206 23.999 -0.000959639 18.6259 5.14575e-07 11.999C-0.00191979 5.37216 5.3711 0 11.999 0C18.627 0 24 5.37312 24 12Z",
    fill: "#EBFF00",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9199 19.1667H6.15991C5.52658 19.1667 4.93991 18.8734 4.55991 18.36C4.17325 17.84 4.05992 17.1867 4.25325 16.5667L7.05991 7.54663C7.31325 6.70663 8.08659 6.1333 8.96659 6.1333H17.1666C17.9732 6.1333 18.6999 6.61336 19.0066 7.36003C19.1733 7.74669 19.2066 8.1867 19.1066 8.62004L16.8599 17.64C16.6466 18.54 15.8466 19.1667 14.9199 19.1667ZM8.97324 7.13997C8.53991 7.13997 8.14658 7.42668 8.01992 7.84668L5.21325 16.8667C5.11992 17.18 5.17325 17.5067 5.37325 17.7734C5.55991 18.0267 5.85325 18.1733 6.16658 18.1733H14.9266C15.3866 18.1733 15.7866 17.86 15.8932 17.4133L18.1399 8.38664C18.1932 8.16664 18.1799 7.94667 18.0933 7.75334C17.9333 7.37334 17.5799 7.1333 17.1733 7.1333H8.97324V7.13997Z",
    fill: "#27313D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8533 19.1666H14.6666C14.3933 19.1666 14.1666 18.9399 14.1666 18.6666C14.1666 18.3932 14.3933 18.1666 14.6666 18.1666H17.8533C18.1266 18.1666 18.38 18.0533 18.5666 17.8533C18.7533 17.6532 18.8466 17.3866 18.8266 17.1133L18.1666 8.03326C18.1466 7.75993 18.3533 7.5199 18.6266 7.4999C18.9 7.48656 19.14 7.68652 19.16 7.95986L19.82 17.0399C19.86 17.5866 19.6666 18.1333 19.2933 18.5333C18.9266 18.9399 18.4 19.1666 17.8533 19.1666Z",
    fill: "#27313D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4531 8.75322C10.4131 8.75322 10.3731 8.74654 10.3331 8.73988C10.0665 8.67321 9.89982 8.40652 9.96648 8.13319L10.6598 5.25322C10.7265 4.98656 10.9931 4.81986 11.2665 4.88652C11.5331 4.95319 11.6998 5.21988 11.6331 5.49321L10.9398 8.37326C10.8865 8.59993 10.6798 8.75322 10.4531 8.75322Z",
    fill: "#27313D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.92 8.76007C14.8866 8.76007 14.8466 8.76006 14.8133 8.74673C14.5466 8.68673 14.3733 8.42005 14.4266 8.15338L15.0533 5.26007C15.1133 4.98674 15.38 4.8201 15.6466 4.87344C15.9133 4.92677 16.0866 5.20003 16.0333 5.4667L15.4066 8.36009C15.3599 8.60009 15.1533 8.76007 14.92 8.76007Z",
    fill: "#27313D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4668 12.5H9.13342C8.86009 12.5 8.63342 12.2733 8.63342 12C8.63342 11.7267 8.86009 11.5 9.13342 11.5H14.4668C14.7401 11.5 14.9668 11.7267 14.9668 12C14.9668 12.2733 14.7401 12.5 14.4668 12.5Z",
    fill: "#27313D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8001 15.1667H8.4668C8.19346 15.1667 7.9668 14.9401 7.9668 14.6667C7.9668 14.3934 8.19346 14.1667 8.4668 14.1667H13.8001C14.0735 14.1667 14.3001 14.3934 14.3001 14.6667C14.3001 14.9401 14.0735 15.1667 13.8001 15.1667Z",
    fill: "#27313D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_5686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirement);
export default __webpack_public_path__ + "static/media/retirement.9f847ee10161917d56990642013998dc.svg";
export { ForwardRef as ReactComponent };